/**
 * @generated SignedSource<<78f6caaab0f4b8c057b32303eb0c8013>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DiscoverViewProductCheckQuery$variables = {
  cloudIds: ReadonlyArray<string>;
};
export type DiscoverViewProductCheckQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly confluence: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type DiscoverViewProductCheckQuery = {
  response: DiscoverViewProductCheckQuery$data;
  variables: DiscoverViewProductCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudIds",
        "variableName": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "alias": "confluence",
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "confluence"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ],
        "storageKey": "activationIdByProduct(product:\"confluence\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "DiscoverViewProductCheckQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscoverViewProductCheckQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b4a5b496d719232b294e7a08f4e2bab5",
    "id": null,
    "metadata": {},
    "name": "DiscoverViewProductCheckQuery",
    "operationKind": "query",
    "text": "query DiscoverViewProductCheckQuery(\n  $cloudIds: [ID!]!\n) {\n  tenantContexts(cloudIds: $cloudIds) {\n    confluence: activationIdByProduct(product: \"confluence\") {\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a680b61d31509af81a423c5b37eef52b";

export default node;
